function checkStatus(response) {
  if (response.status >= 200 && response.status < 300) {
    return response;
  }
  const error = new Error(response.statusText);
  error.response = response;
  throw error;
}


function parseJSON(response) {
  return response.json();
}


class AuthService {
  logInDev = ({ username, password }) => {
    const body = {
      username,
      password,
    };
    const requestOptions = {
      headers: {
        'Content-Type': 'application/json; charset=utf-8',
        // "Content-Type": "application/x-www-form-urlencoded",
      },
      method: 'POST',
      body: JSON.stringify(body),
    };
    return window
      .fetch('/auth', requestOptions)
      .then(checkStatus)
      .then(parseJSON);
  };

  logInProd = ({ username, password }) => {
    const body = {
      username,
      password,
    };
    const requestOptions = {
      headers: {
        'Content-Type': 'application/json; charset=utf-8',
        // "Content-Type": "application/x-www-form-urlencoded",
      },
      method: 'POST',
      body: JSON.stringify(body),
    };

    return window
      .fetch('/auth', requestOptions)
      .then(checkStatus)
      .then(parseJSON);
  }
}

export const authService = new AuthService();



// WEBPACK FOOTER //
// ./src/Auth/AuthService.js